// Английски превод — auth. Ключ = българският текст от кода.
// (Общите ключове — „Изход“, „Отказ“, „Профил“, ролите и т.н. — са в en.common.ts.)
export const EN_AUTH: Record<string, string> = {
  // LoginScreen
  'Вход с парола': 'Log in with password',
  'Първи вход (наемател)': 'First login (tenant)',
  'Телефон или имейл': 'Phone or email',
  '+359 88 812 3456 или ime@poshta.bg': '+359 88 812 3456 or name@mail.com',
  'Парола': 'Password',
  'Вход': 'Log in',
  'Забравена парола?': 'Forgotten your password?',
  'Само за поканен наемател/собственик — при първия вход получавате SMS код и си задавате парола. След това влизате с нея. Криейтърите се регистрират от линка в поканата си.':
    'Only for invited tenants/owners — on your first login you receive an SMS code and set a password. After that you log in with it. Creators sign up via the link in their invitation.',
  'Телефон (на който сте поканени)': 'Phone (the one you were invited on)',
  'Изпрати код': 'Send code',
  'Нямате акаунт?': "Don't have an account?",
  'Наемодател, пропърти мениджър или майстор — регистрирайте се с телефон и парола.':
    'Landlord, property manager or handyman — sign up with a phone number and password.',
  'Провери наемател 🔍': 'Check a tenant 🔍',
  'Въведи телефона на наемател (или наемодател, майстор) — виж дали има отзиви, преди да дадеш ключовете.':
    'Enter the phone number of a tenant (or landlord, handyman) — see if they have reviews before handing over the keys.',
  // OtpScreen
  'Потвърждение': 'Confirmation',
  'Кодът ви е в SMS-а с поканата — важи 24 часа от изпращането.': 'Your code is in the invitation SMS — it is valid for 24 hours after sending.',
  'Изпратихме 6-цифрен код на {phone}.': 'We sent a 6-digit code to {phone}.',
  'Потвърди': 'Confirm',
  'Нов код': 'New code',
  'Вече имате изпратен код — той е в SMS-а с поканата и важи 24 часа.': 'A code was already sent — it is in the invitation SMS and is valid for 24 hours.',
  'Изпратихме нов код.': 'We sent a new code.',
  // ForgotPasswordScreen
  'Изпратихме код по SMS.': 'We sent a code by SMS.',
  'Паролата е сменена. Влезте с новата.': 'Password changed. Log in with the new one.',
  'Въведете телефона и имейла от профила си — двете трябва да съвпадат, за да изпратим код. Възможно е най-много 2 пъти на 12 часа.':
    'Enter the phone number and email from your profile — both must match for us to send a code. Possible at most 2 times per 12 hours.',
  'Телефон': 'Phone',
  'Имейл': 'Email',
  'Изпрати код по SMS': 'Send code by SMS',
  'Назад към входа': 'Back to login',
  'Изпратихме 6-цифрен код на {phone}. Въведете го и изберете нова парола.': 'We sent a 6-digit code to {phone}. Enter it and choose a new password.',
  'Нова парола (мин. 8 знака)': 'New password (min. 8 characters)',
  'Смяната прекратява всички активни сесии — влизате наново само вие.': 'Changing it ends all active sessions — only you log in again.',
  'Смени паролата': 'Change password',
  // RegisterScreen
  'Отдавате собствени имоти': 'You rent out your own properties',
  'Управлявате чужди имоти (фирма)': 'You manage properties for others (company)',
  'Получавате заявки за ремонти': 'You receive repair requests',
  'Потвърдете номера си': 'Confirm your number',
  'Изпратихме 6-цифрен код на {phone}. Така се уверяваме, че номерът е ваш.': 'We sent a 6-digit code to {phone}. This is how we make sure the number is yours.',
  'Потвърди и се регистрирай': 'Confirm and sign up',
  'Назад': 'Back',
  'Бърза регистрация — за наемодатели, пропърти мениджъри и майстори.': 'Quick sign-up — for landlords, property managers and handymen.',
  'Телефон: {phone}': 'Phone: {phone}',
  '🎁 Първите {n} регистрирани получават {trial} безплатно': '🎁 The first {n} to sign up get {trial} free',
  'Остават {n} места — печелите го автоматично при регистрация.': '{n} spots left — you get it automatically when you sign up.',
  'Поканени сте като наемател 🏠': 'You are invited as a tenant 🏠',
  'Наемодателят ви е добавил с този номер. Остава само да въведете имената си.': 'Your landlord added you with this number. All that is left is to enter your name.',
  'Поканени сте като собственик 🔑': 'You are invited as an owner 🔑',
  'Пропърти мениджър управлява ваш имот. Остава само да въведете имената си.': 'A property manager manages your property. All that is left is to enter your name.',
  'Поканени сте като обитател 🏠': 'You are invited as a resident 🏠',
  'Наемодателят ви е добавил като живеещ в имота. Ще можете да подавате нередности за жилището. Остава само да въведете имената си.':
    'Your landlord added you as living in the property. You will be able to report issues with the home. All that is left is to enter your name.',
  'Регистрирам се като': 'I am signing up as',
  'Наемател сте? Не е нужна регистрация — наемодателят ви кани по телефон и влизате с SMS код.':
    'Are you a tenant? No sign-up needed — your landlord invites you by phone and you log in with an SMS code.',
  'Какъв сте?': 'What are you?',
  'Име': 'First name',
  'Иван': 'Ivan',
  'Фамилия': 'Last name',
  'Иванов': 'Ivanov',
  'Имейл (по избор)': 'Email (optional)',
  'Парола (мин. 8 знака)': 'Password (min. 8 characters)',
  'С нея влизате всеки път — по телефон или имейл.': 'You log in with it every time — by phone or email.',
  'Искам да добавя име, имейл или фирма →': 'I want to add a name, email or company →',
  'ЕГН': 'Personal ID number (EGN)',
  'напр. 7523169263': 'e.g. 7523169263',
  'Адрес по лична карта': 'Address as on ID card',
  'гр. …, ул. …, №': 'City, street, no.',
  'Нужни са за договор и фактура. ЕГН се пази криптирано и се вижда само от наемодателя.':
    'Needed for the contract and invoice. The personal ID number is stored encrypted and visible only to the landlord.',
  'Регистрирам фирма (с ЕИК)': 'I am registering a company (with company ID)',
  'Име на фирмата': 'Company name',
  'Имоти ЕООД': 'Properties Ltd',
  'ЕИК': 'Company ID (EIK)',
  'МОЛ': 'Company representative (MOL)',
  'Иван Иванов': 'Ivan Ivanov',
  'ДДС номер (по избор)': 'VAT number (optional)',
  'Реквизитите влизат в договорите и фактурите.': 'These details go into the contracts and invoices.',
  'Области, в които работите': 'Regions you work in',
  'Ще получавате запитвания от всички населени места в избраните области.': 'You will receive requests from all towns and villages in the selected regions.',
  'Какъв майстор сте? (може повече от едно)': 'What kind of handyman are you? (more than one allowed)',
  'Изберете специалност…': 'Choose a specialty…',
  'Съгласен съм личните ми данни да се обработват за целите на приложението (GDPR).': 'I agree to my personal data being processed for the purposes of the app (GDPR).',
  'С регистрацията приемате': 'By signing up you accept the',
  'Продължи — код по SMS': 'Continue — code by SMS',
  'Регистрирай ме': 'Sign me up',
  'Безплатно · без карта · отнема 1 минута': 'Free · no card · takes 1 minute',
  // CompleteNameScreen
  'Добре дошли в Livupp 👋': 'Welcome to Livupp 👋',
  'Само още едно нещо — как да ви наричаме? Имената влизат в договорите и фактурите ви.': 'Just one more thing — what should we call you? Your name goes into your contracts and invoices.',
  'Продължи': 'Continue',
  // SecuritySetupScreen
  'Двата ПИН-а не съвпадат — започнете отначало.': 'The two PINs do not match — start over.',
  'Готово — приложението се отключва с ПИН.': 'Done — the app unlocks with a PIN.',
  'Потвърдете, за да включите': 'Confirm to enable',
  'Готово — отключвате с лице/отпечатък, а ПИН-ът е резервен.': 'Done — you unlock with Face ID/fingerprint, and the PIN is the backup.',
  'Защитете приложението': 'Protect the app',
  'В Livupp има лични данни и плащания. Изберете как да се отключва на този телефон — отнема половин минута.':
    'Livupp holds personal data and payments. Choose how it unlocks on this phone — it takes half a minute.',
  '1. Изберете 4-цифрен ПИН': '1. Choose a 4-digit PIN',
  'Повторете ПИН-а': 'Repeat the PIN',
  'ПИН-ът важи само за този телефон. Не е паролата на акаунта ви.': 'The PIN applies only to this phone. It is not your account password.',
  'Пропусни — без заключване': 'Skip — no lock',
  '2. Лицево разпознаване / отпечатък': '2. Face ID / fingerprint',
  'Отключвайте с поглед или пръст — по-бързо е от ПИН. ПИН-ът остава като резервен вариант.': 'Unlock with a glance or a finger — faster than a PIN. The PIN remains as a backup.',
  'Включи': 'Enable',
  'Само с ПИН': 'PIN only',
  // ProfileScreen
  'Моите данни в Livupp': 'My data in Livupp',
  'Акаунтът е изтрит. Личните ви данни са заличени.': 'Account deleted. Your personal data has been erased.',
  'Паролата е запазена — вече влизате без SMS, с телефон или имейл.': 'Password saved — you can now log in without SMS, with phone or email.',
  'Включено — при отваряне Livupp ще иска лицево разпознаване/отпечатък.': 'Enabled — Livupp will ask for Face ID/fingerprint when opened.',
  'Невалидна дата. Използвайте дд.мм.гггг.': 'Invalid date. Use dd.mm.yyyy.',
  'Данните са запазени.': 'Details saved.',
  'Реквизитите за фактури са запазени.': 'Invoice details saved.',
  'IBAN-ът е запазен.': 'IBAN saved.',
  'Областите са запазени.': 'Regions saved.',
  'Роля': 'Role',
  'Език': 'Language',
  'Автоматично': 'Automatic',
  'Автоматично: според телефона и местоположението.': 'Automatic: based on your phone and location.',
  'IBAN за получаване на наема': 'IBAN for receiving rent',
  'Видим е за наемателите ви при плащане по банка.': 'Visible to your tenants when paying by bank transfer.',
  'Запази IBAN': 'Save IBAN',
  'Получавате запитвания от всички населени места в избраните области.': 'You receive requests from all towns and villages in the selected regions.',
  'Запази областите': 'Save regions',
  'Данни за договори и фактури': 'Details for contracts and invoices',
  'Липсват данни — наемодателят не може да ви издаде документи': 'Missing details — the landlord cannot issue documents to you',
  'Презиме': 'Middle name',
  'за пълното име в договора': 'for the full name in the contract',
  'Лична карта №': 'ID card no.',
  'Издадена на': 'Issued on',
  'дд.мм.гггг': 'dd.mm.yyyy',
  'От РПУ на МВР — град': 'Issued by (police department) — city',
  'напр. София': 'e.g. Sofia',
  'ЕГН се пази криптирано и се вижда само от наемодателя ви. Данните от личната карта влизат в договора.':
    'The personal ID number is stored encrypted and visible only to your landlord. The ID card details go into the contract.',
  'Запази': 'Save',
  'Мои данни за договора': 'My details for the contract',
  'Влизат в договора за наем на мястото на вашите данни. Попълват се веднъж.': 'They go into the rental contract as your details. Fill them in once.',
  'напр. Пловдив': 'e.g. Plovdiv',
  'Адрес': 'Address',
  'Данни за фактури': 'Invoice details',
  'Град': 'City',
  'София': 'Sofia',
  'ул. …, №': 'Street, no.',
  'МОЛ (за фирма)': 'Company representative (for a company)',
  'Банка': 'Bank',
  'ДСК': 'DSK',
  'Регистриран по ЗДДС': 'VAT registered',
  'Освободена доставка (чл. 45 ЗДДС — жилище на физ. лице)': 'VAT-exempt supply (Art. 45 VAT Act — dwelling of a private individual)',
  'ДДС режимът определя как се начислява данъкът във фактурите. При съмнение се консултирайте със счетоводител — приложението не взима данъчни решения вместо вас.':
    'The VAT regime determines how tax is charged on invoices. If in doubt, consult an accountant — the app does not make tax decisions for you.',
  'Запази реквизитите': 'Save details',
  'Вход и сигурност': 'Login and security',
  'Задайте парола, за да влизате без SMS код — с телефон или имейл.': 'Set a password to log in without an SMS code — with phone or email.',
  'Запази паролата': 'Save password',
  'Изисквай лицево разпознаване / отпечатък при отваряне': 'Require Face ID / fingerprint on open',
  'Лицево разпознаване не е налично на това устройство.': 'Face recognition is not available on this device.',
  'Моите данни': 'My data',
  'Свалете копие на всичко, което Livupp пази за вас, или изтрийте акаунта си заедно с личните данни.':
    'Download a copy of everything Livupp keeps about you, or delete your account together with your personal data.',
  'Изтегли моите данни': 'Download my data',
  'Изтриване на акаунта': 'Delete account',
  'Проверяваме дали имате незавършени ангажименти…': 'Checking whether you have unfinished commitments…',
  'Акаунтът не може да бъде изтрит сега': 'The account cannot be deleted right now',
  'Това действие е необратимо.': 'This action is irreversible.',
  'Името, телефонът, имейлът, ЕГН-то, IBAN-ът и снимките на личната ви карта се заличават завинаги. Договорите, фактурите и плащанията остават анонимизирани — законът изисква да се пазят 10 години (чл. 12 ЗСч). Въведете паролата си, за да потвърдите.':
    'Your name, phone, email, personal ID number, IBAN and ID card photos are erased forever. Contracts, invoices and payments remain anonymised — the law requires them to be kept for 10 years (Art. 12 Accountancy Act). Enter your password to confirm.',
  'Вашата парола': 'Your password',
  'Изтрий акаунта завинаги': 'Delete account forever',
  'Помощ': 'Help',
  'Нещо не работи или имате въпрос? Пишете ни — отговаряме бързо.': 'Something not working or have a question? Write to us — we reply quickly.',
  '✉️ Съобщи проблем / поддръжка': '✉️ Report a problem / support',
  'Правна информация': 'Legal information',
  // MoreScreen
  'Пари и документи': 'Money and documents',
  'Имоти и наематели': 'Properties and tenants',
  'Нередности и ремонти': 'Issues and repairs',
  'Търсене': 'Search',
  // SupportScreen
  '🛠 Проблем': '🛠 Problem',
  '❓ Въпрос': '❓ Question',
  '💡 Идея': '💡 Idea',
  '✉️ Друго': '✉️ Other',
  'Благодарим! Получихме съобщението ви и ще се свържем с вас.': 'Thank you! We received your message and will get in touch.',
  'Свържете се с нас': 'Contact us',
  'Опишете проблема, въпроса или идеята си — екипът на Livupp ще ви отговори по телефон или имейл.': 'Describe your problem, question or idea — the Livupp team will reply by phone or email.',
  'Тема': 'Topic',
  'Вашият имейл': 'Your email',
  'Нямате въведен имейл. Ще го запазим в профила ви, за да ви отговорим.': 'You have no email on file. We will save it to your profile so we can reply.',
  'Съобщение': 'Message',
  'Опишете какво се случва…': 'Describe what is happening…',
  'Изпрати': 'Send',
  'Или директно: info@livupp.com': 'Or directly: info@livupp.com',
  'Пиши на info@livupp.com': 'Email info@livupp.com',
  // NotificationsScreen
  'Маркирай всички като прочетени': 'Mark all as read',
  'Нямате известия.': 'You have no notifications.',
  'Само проверка на наемател →': 'Just check a tenant →',
};
